import React, { Fragment } from "react";

import getImageObject from "src/helpers/getImageObject";

import Image from "src/components/UI/Image";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Box from "src/components/UI/Structure/Box";
import Text from "src/components/UI/Text";
import Chapter from "src/components/UI/Typography/Chapter";

const Chapters = ({ chapters }) => {
  return (
    <Fragment>
      {chapters.map(({ title, text, images }, i) => (
        <Grid key={i} justifyContent="space-between" mb={[4]}>
          <Column
            width={[12 / 12, null, null, 6 / 12, 4 / 12]}
            mb={8}
            ml={[0, null, null, null, (1 / 12) * 100 + "%"]}
          >
            <div className="content">
              {title && <Chapter>{title}</Chapter>}
              {text && (
                <Text
                  fontSize={[3, null, null, null, 4, 5]}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
            </div>
          </Column>
          {images && (
            <Column width={[12 / 12, null, null, 5 / 12]}>
              {images.map(({ image }, i) => (
                <Box key={i} mb={8} mr="-32px" ml={["-32px", null, null, 0]}>
                  <Image image={getImageObject(image)} />
                </Box>
              ))}
            </Column>
          )}
        </Grid>
      ))}
    </Fragment>
  );
};

export default Chapters;
